import React from "react";
import { PropTypes } from "prop-types";
import { Card, Button } from "react-bootstrap";
import { connect } from "react-redux";
import moment from "moment";
import { useParams } from "react-router-dom";
import { BiPlusMedical, BiTrash } from "react-icons/bi";
import { FaEdit } from "react-icons/fa";

import PiDataTable from "views/DataTable/PiDataTable";
import CreateProviderCredentialModal from "./CreateProviderCredentialModal";

import {
  getProviderCredentialList,
  resetProviderCredentialComponentStore,
  deleteProviderCredential,
} from "actions/providerCredentialActions";

const ProviderCredentialsList = ({
  providerCredentialList: { data, count },
  getProviderCredentialList,
  deleteProviderCredential,
  resetProviderCredentialComponentStore,
  sortingParams,
  loadingProviderCredentialList,
}) => {
  const { provider_id } = useParams();

  const initialSortingParams = {
    limit: 10,
    page: 1,
    orderBy: "createdAt",
    ascending: "desc",
    query: "",
    filters: [],
  };

  const { page } = sortingParams;

  const [clientParams, setClientParams] = React.useState(initialSortingParams);
  const [onlyOnce, setOnce] = React.useState(true);

  const [isLoadingMore, setLoadingMore] = React.useState(false);

  const [credentialID, setCredentialID] = React.useState(null);

  const [modal, setModal] = React.useState(false);

  const columns = [
    {
      name: "Credential",
      selector: (row) => row.credential.code,
      sortable: false,
      width: "15%",
    },

    {
      name: "State",
      selector: (row) => row.state,
      sortable: false,
      width: "5%",
    },
    {
      name: "License Number",
      selector: (row) => row.license_number,
      sortable: false,
      width: "15%",
    },

    {
      name: "Date Issued",
      cell: (row) =>
        row.date_issued ? moment(row.date_issued).format("MM/DD/YYYY") : "-",
      sortable: false,
      width: "10%",
    },

    {
      name: "Date Effective",
      cell: (row) =>
        row.date_effective
          ? moment(row.date_effective).format("MM/DD/YYYY")
          : "-",
      sortable: false,
      width: "10%",
    },
    {
      name: "Date Expires",
      cell: (row) =>
        row.date_expires ? moment(row.date_expires).format("MM/DD/YYYY") : "-",
      sortable: false,
      width: "10%",
    },
    {
      name: "Status",
      cell: (row) => (
        <React.Fragment>
          {row.verified ? "Verified" : "Not Verified"}
        </React.Fragment>
      ),
      sortable: false,
      width: "10%",
    },
    {
      name: "Date Verified",
      cell: (row) => (
        <React.Fragment>
          {row.date_verified
            ? moment(row.date_verified).format("MM/DD/YYYY")
            : "-"}
        </React.Fragment>
      ),
      sortable: false,
      width: "10%",
    },
    {
      name: "Actions",
      width: "15%",
      button: true,
      cell: (row) => (
        <div className="App table-list-buttons">
          <Button
            variant="link"
            size="sm"
            onClick={() => onEditClickHandle(row._id)}
          >
            <FaEdit />
          </Button>

          <Button
            className="ml-1 c-red"
            size="sm"
            type="button"
            variant="link"
            onClick={(e) => {
              if (
                window.confirm(
                  `Are you sure you want to delete: ${row.credential.code}?`
                )
              ) {
                deleteProviderCredential(provider_id, row._id);
              }
            }}
          >
            <BiTrash />
          </Button>
        </div>
      ),
    },
  ];

  const onClickHandle = () => {
    setModal(true);
  };

  const handleLoadmore = () => {
    setLoadingMore(true);
    setClientParams({
      ...clientParams,
      page: page + 1,
    });
  };

  const onEditClickHandle = (provider_credential_id) => {
    setModal(true);
    setCredentialID(provider_credential_id);
  };

  React.useEffect(() => {
    if (onlyOnce) {
      resetProviderCredentialComponentStore();
      setOnce(false);
    }

    getProviderCredentialList(clientParams, provider_id)
      .then((res) => {
        setLoadingMore(false);
      })
      .catch((error) => {
        setLoadingMore(false);
      });
  }, [
    getProviderCredentialList,
    clientParams,
    provider_id,
    resetProviderCredentialComponentStore,
  ]);

  return (
    <React.Fragment>
      <CreateProviderCredentialModal
        modal={modal}
        setModal={setModal}
        credentialID={credentialID}
        setCredentialID={setCredentialID}
      />

      <Card className="mt-5">
        <Card.Body>
          <div className="card-heading">
            <h4 className="header-title">Credentials</h4>

            <Button
              variant="link"
              size="sm"
              className="float-end"
              onClick={() => onClickHandle()}
            >
              <BiPlusMedical title="Click to Add" size={20} />
            </Button>
          </div>

          {data.length || loadingProviderCredentialList ? (
            <PiDataTable
              columns={columns}
              data={data}
              count={count}
              params={clientParams}
              setParams={setClientParams}
              responsive
              striped={true}
              progressPending={loadingProviderCredentialList && !isLoadingMore}
              highlightOnHover
              persistTableHead={true}
              paginationServer
            />
          ) : (
            <p align="center">
              There are no records to display. Click + icon to add credential.
            </p>
          )}

          {count === data.length ? null : (
            <div className="text-center mt-2">
              <Button onClick={handleLoadmore} variant="link">
                {isLoadingMore ? "Loading..." : "Load More"}
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

ProviderCredentialsList.propTypes = {
  getProviderCredentialList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  providerCredentialList: state.providerCredential.providerCredentialList,
  loadingProviderCredentialList:
    state.providerCredential.loadingProviderCredentialList,
  sortingParams: state.providerCredential.sortingParams,
});

export default connect(mapStateToProps, {
  getProviderCredentialList,
  resetProviderCredentialComponentStore,
  deleteProviderCredential,
})(ProviderCredentialsList);
